import { useState } from "react";
import { toast } from "react-toastify";
import "./RegisterVendor.scss";
import http from "../../services/http-commons";
import { useNavigate } from "react-router-dom";

const VendorSignup = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [errorCode, setErrorCode] = useState(null);
  const [vendorData, setVendorData] = useState({
    business_name: "",
    category_focus: "",
    bank_name: "",
    account_number: "",
  });

  const banks = [
    "GTBank",
    "Access Bank",
    "UBA",
    "Zenith Bank",
    "First Bank",
    "Fidelity Bank",
    "Opay",
    "Moniepoint",
  ];

  const categories = [
    "Fashion",
    "Electronics",
    "Groceries",
    "Beauty",
    "General",
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setVendorData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const registerVendor = () => {
    const payload = {
      business_name: vendorData.business_name,
      category_focus: vendorData.category_focus,
      payout_account: JSON.stringify({
        bank_name: vendorData.bank_name,
        account_number: vendorData.account_number,
      }),
    };

    const request = http.REGISTERVENDORHTTP.post("/register", payload);
    setLoading(true);

    toast.promise(
      request,
      {
        pending: "Creating account...",
        success: "Vendor Account created successfully 🎉",
        error: "Unable to create account 😞",
      },
      {
        autoClose: 3000,
      },
    );

    request
      .catch((error) => {
        // let errorMessage = "An unexpected error occurred.";

        if (error.response) {
          if (error.response.status === 404) {
            setError("No vendor found.");
            // errorMessage = "No vendor found.";
            setErrorCode(404);
          } else if (error.response.status === 500) {
            setError(
              "Something went wrong on the server. Please try again later.",
            );
            // errorMessage = "Something went wrong on the server. Please try again later.";
            setErrorCode(500);
          } else if (error.response.status === 401) {
            setError("Unauthorized. Please log in to continue.");
            // errorMessage = "Unauthorized. Please log in to continue.";
            setErrorCode(401);
          } else {
            const detail =
              error.response.data?.detail ||
              "An unexpected error occurred. Please try again.";
            setError(detail);
            // errorMessage = detail;
            setErrorCode(error.response.status);
          }
        } else if (error.request) {
          setError("No response from server. Check your connection.");
          // errorMessage = "No response from server. Check your connection.";
        } else {
          setError(`Error: ${error.message}`);
          // errorMessage = `Error: ${error.message}`;
        }

        // OPTIONAL: If you want toast.promise to display your dynamic backend
        // errorMessage instead of the static "Unable to create account 😞" string,
        // you can throw the error or return a rejected promise here.
      })
      .finally(() => {
        // 4. This always runs regardless of success or failure
        setLoading(false);
      });
  };

  // =================== Loading ===================

  if (loading) {
    return (
      <div className="order-state-container">
        <div className="order-loader"></div>
        <p>Loading your registration...</p>
      </div>
    );
  }

  // =================== Login Required ===================

  if (errorCode === 401) {
    return (
      <div className="order-state-container">
        <div className="order-state-card">
          <div className="order-state-icon">🔐</div>

          <h2>Login Required</h2>

          <p>
            Please log in to your Banke account to view your orders and track
            your purchases.
          </p>

          <button
            className="order-login-btn"
            onClick={() => navigate("/auth/login")}
          >
            Log In
          </button>
        </div>
      </div>
    );
  }

  // =================== Other Errors ===================

  if (error) {
    return (
      <div className="order-state-container">
        <div className="order-state-card">
          <div className="order-state-icon">⚠️</div>

          <h2>Something went wrong</h2>

          <p>{error}</p>

          <button
            className="order-login-btn"
            onClick={() => window.location.reload()}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="vendor-signup">
      <div className="signup-card">
        <div className="text-center mb-4">
          <h3>Create Your Vendor Account</h3>

          <p className="text-muted">Join our platform and start selling</p>
        </div>

        {/* Business Name */}
        <div className="mb-3">
          <label htmlFor="businessName" className="form-label">
            Business Name
          </label>

          <input
            id="businessName"
            name="business_name"
            type="text"
            value={vendorData.business_name}
            onChange={handleInputChange}
            className="form-control form-control-lg"
            placeholder="Enter business name"
          />
        </div>

        {/* Category */}
        <div className="mb-3">
          <label htmlFor="categoryFocus" className="form-label">
            Category Focus
          </label>

          <select
            id="categoryFocus"
            name="category_focus"
            value={vendorData.category_focus}
            onChange={handleInputChange}
            className="form-control form-control-lg"
          >
            <option value="">Select category</option>

            {categories.map((category) => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>

        <div className="row">
          {/* Bank Name */}
          <div className="col-md-6 mb-3">
            <label htmlFor="bankName" className="form-label">
              Bank Name
            </label>

            <select
              id="bankName"
              name="bank_name"
              value={vendorData.bank_name}
              onChange={handleInputChange}
              className="form-control form-control-lg"
            >
              <option value="">Select bank</option>

              {banks.map((bank) => (
                <option key={bank} value={bank}>
                  {bank}
                </option>
              ))}
            </select>
          </div>

          {/* Account Number */}
          <div className="col-md-6 mb-3">
            <label htmlFor="accountNumber" className="form-label">
              Account Number
            </label>

            <input
              id="accountNumber"
              name="account_number"
              type="text"
              value={vendorData.account_number}
              onChange={handleInputChange}
              className="form-control form-control-lg"
              placeholder="0123456789"
            />
          </div>
        </div>

        <button className="btn btn-primary w-100" onClick={registerVendor}>
          Create Account
        </button>
        <div className="text-center mt-3">
          <span className="text-muted">Already have an account?</span>

          <a
            href="https://vendor.banke.com.ng/login"
            className="ms-1 text-decoration-none fw-semibold"
          >
            Sign In
          </a>
        </div>
      </div>
    </div>
  );
};

export default VendorSignup;
